module.exports = __webpack_public_path__ + "static/media/gradiant_round_check.f7bb918a.png";